module.exports = __webpack_public_path__ + "static/img/scene-6.416ea50e.jpg";